(function () {
    'use strict';

    angular.module('eDocumentsApp').controller('UserManagementController', UserManagementController);

    UserManagementController.$inject = ['Principal', 'User', 'ParseLinks', 'AlertService', '$state', 'pagingParams', 'paginationConstants', 'JhiLanguageService', 'UserAccessWindow'];

    function UserManagementController(Principal, User, ParseLinks, AlertService, $state, pagingParams, paginationConstants, JhiLanguageService, UserAccessWindow) {
        var vm = this;

        // SUP-12293: when an account's access ends (external auditors)
        vm.accessHasEnded = function (user) {
            return UserAccessWindow.hasEnded(user.accessValidUntil);
        };
        vm.accessLastDay = function (user) {
            return UserAccessWindow.lastDay(user.accessValidUntil);
        };

        vm.authorities = ['ROLE_USER', 'ROLE_ADMIN', 'ROLE_PARTNER', 'ROLE_SUPERADMIN', 'ROLE_BETATESTER', 'ROLE_INTEGRATION', 'ROLE_DIGITAL_ARCHIVE'];
        vm.currentAccount = null;
        vm.languages = null;
        vm.loadAll = loadAll;
        vm.setActive = setActive;
        vm.users = [];
        vm.page = 1;
        vm.totalItems = null;
        vm.clear = clear;
        vm.links = null;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.searchQuery = pagingParams.search;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.transition = transition;

        vm.loadAll();
        JhiLanguageService.getAll().then(function (languages) {
            vm.languages = languages;
        });
        Principal.identity().then(function (account) {
            vm.currentAccount = account;
        });

        /**
         * Why this account cannot be deactivated from the list, as an i18n key, or null when it can.
         * Activating is always allowed. The button stays focusable (aria-disabled) so the reason can be
         * read and shown, which is why setActive also refuses: the click still reaches it.
         */
        vm.deactivationBlockedReason = function (user) {
            if (!user.activated) {
                return null;
            }
            if (vm.currentAccount && vm.currentAccount.login === user.login) {
                return 'userManagement.cannotDeactivate.ownAccount';
            }
            if (user.authorities && user.authorities.indexOf('ROLE_SUPERADMIN') !== -1) {
                return 'userManagement.cannotDeactivate.superadmin';
            }
            return null;
        };

        function setActive(user, isActivated) {
            if (!isActivated && vm.deactivationBlockedReason(user)) {
                return;
            }
            user.activated = isActivated;
            User.update(user, function () {
                vm.loadAll();
                vm.clear();
            }, function () {
                user.activated = !isActivated;
            });
        }

        function loadAll() {
            User.query(
                {
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    search: search(),
                    sort: sort(),
                },
        onSuccess,
        onError
      );
        }

        function search() {
            return vm.searchQuery;
        }

        function onSuccess(data, headers) {
            vm.links = ParseLinks.parse(headers('link'));
            vm.totalItems = headers('X-Total-Count');
            vm.queryCount = vm.totalItems;
            vm.page = pagingParams.page;
            vm.users = data;
        }

        function onError(error) {
            AlertService.error(error.data.message);
        }

        function clear() {
            vm.searchQuery = undefined;
            vm.loadAll();
        }

        function sort() {
            var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
            if (vm.predicate !== 'id') {
                result.push('id');
            }
            return result;
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: search(),
            });
        }
    }
})();
